// JS
// body js

export default class BodyClasses {

    constructor() {

        const body = document.querySelector('body') ;

        body.classList.add("js");
        body.classList.remove("no-js");
    }

}